import { useEffect, useState } from "react";
import { useRoomContext } from "@livekit/components-react";
import {
  DataPacket_Kind,
  LocalParticipant,
  RemoteParticipant,
} from "livekit-client";
import { UserState } from "../types";

export const useDominantSpeakerLanguage = () => {
  const [dominantSpeakerLanguage, setDominantSpeakerLanguage] = useState<
    string | undefined
  >();
  const room = useRoomContext();

  useEffect(() => {
    const onParticipantMetadataChanged = (
      _: string | undefined,
      participant: LocalParticipant | RemoteParticipant
    ) => {
      if (!participant.metadata) {
        return;
      }

      const metadata = JSON.parse(participant.metadata) as {
        participant_type: UserState["metadata"]["participantType"];
        language: string;
      };
      console.log(`participant metadata: ${participant.metadata}`);
      if (metadata.participant_type !== "speaker") {
        return;
      }

      if (metadata.language === "autodetect") {
        return;
      }

      console.debug("dominant speaker language", metadata.language);
      setDominantSpeakerLanguage(metadata.language);
    };

    room.on("participantMetadataChanged", onParticipantMetadataChanged);

    return () => {
      room.off("participantMetadataChanged", onParticipantMetadataChanged);
    };
  }, [room]);

  useEffect(() => {
    const decoder = new TextDecoder();
    const onDataReceived = async (
      payload: Uint8Array,
      _?: RemoteParticipant,
      __?: DataPacket_Kind,
      topic?: string
    ) => {
      if (topic !== "autodetect_source_language") {
        return;
      }

      const event = JSON.parse(decoder.decode(payload)) as {
        language: string;
      };

      console.debug("auto detect dominant speaker language", event.language);
      setDominantSpeakerLanguage(event.language);
    };
    room.on("dataReceived", onDataReceived);

    return () => {
      room.off("dataReceived", onDataReceived);
    };
  });

  return dominantSpeakerLanguage;
};
